import React from 'react';
import PropTypes from 'prop-types';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import StyledEngineProvider from '@mui/styled-engine/StyledEngineProvider';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';

import i18next from '../../src/i18n/config';
import { isUserSettingEnabled } from '../../src/services/auth';

import { SnackbarUtilsConfigurator } from "../../src/util/SnackbarUtils"
import theme, { withLinksUnderlined } from '../../src/theme';

export default function TopLayout(props) {
  // add action to all snackbars
  const notistackRef = React.createRef();
  const onClickDismiss = key => () => {
      notistackRef.current.closeSnackbar(key);
  };

  const themeForProvider = isUserSettingEnabled("underline_all_links") ? withLinksUnderlined(theme) : theme;

  return (
    <React.Fragment>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeForProvider}>
          <I18nextProvider i18n={i18next}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              ref={notistackRef}
              action={(key) => (
                <Button color="inherit" size="small" onClick={onClickDismiss(key)}>Dismiss</Button>
              )}>
              <SnackbarUtilsConfigurator/>
              {props.children}
            </SnackbarProvider>
          </I18nextProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </React.Fragment>
  );
}

TopLayout.propTypes = {
  children: PropTypes.node,
};

// Gatsby Head API - handles HTML head elements
export function Head() {
  return (
    <>
      <html lang="en" />
      <title>DubBot</title>
    </>
  );
}
